import { Component, Input } from '@angular/core';

export interface InnerPageNavigationItem {
    routerLink: string;
    tabLabelKey: string;
    completed?: number;
    total?: number;
}

@Component({
    selector: 'inner-page-tab-navigation',
    template: `<div class="tabs-container">
        <ng-container *ngFor="let tab of navigationItems">
            <div
                class="tab"
                [class.active]="tab.active"
                [class.warning]="
                    (mappingCashflowVersionMismatch &&
                        tab.tabLabelKey === 'aumico_reports_annualreport_navigation_cfs') ||
                    (mappingFCPVersionMismatch && tab.tabLabelKey === 'aumico_reports_annualreport_navigation_fcp')
                "
                [routerLink]="tab.routerLink"
                routerLinkActive="active"
            >
                <div
                    *ngIf="
                        (mappingCashflowVersionMismatch &&
                            tab.tabLabelKey === 'aumico_reports_annualreport_navigation_cfs') ||
                            (mappingFCPVersionMismatch &&
                                tab.tabLabelKey === 'aumico_reports_annualreport_navigation_fcp');
                        else noMismatch
                    "
                    class="flex"
                    tooltipPosition="top"
                    backGroundHexColor="#1F2A37"
                    [hamTooltip]="'aumico_reports_tooltip_text_verify_data' | i18next"
                    [withArrow]="true"
                >
                    <span>
                        {{ tab.tabLabelKey | i18next }}
                    </span>
                    <span *ngIf="tab.completed && tab.total" class="counter">
                        {{ tab.completed }}/{{ tab.total }}
                    </span>
                </div>

                <ng-template #noMismatch>
                    <span>
                        {{ tab.tabLabelKey | i18next }}
                    </span>
                    <span *ngIf="tab.completed && tab.total" class="counter">
                        {{ tab.completed }}/{{ tab.total }}
                    </span>
                </ng-template>
            </div>

            <ng-content></ng-content>
        </ng-container>
    </div>`,
    styleUrls: ['./inner-page-tab-navigation.component.scss'],
})
export class InnerPageTabNavigationComponent {
    @Input() navigationItems: InnerPageNavigationItem[] = [];
    @Input() mappingCashflowVersionMismatch = false;
    @Input() mappingFCPVersionMismatch = false;
}
